// TSS vite/04 §"Endpoint paths". baseURL ya incluye /api/v1.
// Preñeces + ciclo de vida del diagnóstico (admin-pregnancies.md).

export const pregnancyPaths = {
    list:           ()         => 'admin/pregnancies',
    detail:         (id)       => `admin/pregnancies/${id}`,
    diagnostics:    (id)       => `admin/pregnancies/${id}/diagnostics`,
    // PATCH del último dx registrado (0031): corrige date/result y recalcula estado.
    diagnosticItem: (id, dxId) => `admin/pregnancies/${id}/diagnostics/${dxId}`,
};
